<ng-container *transloco="let _t">

<h5>{{ _t('audit-pdf-dialog-h5-0') }}</h5>

<p><span>{{ _t('audit-pdf-dialog-span-0') }}</span> :<br>
    <a target="_blank" [href]="data.pdfUrl"
		mat-raised-button color="primary" >
		<mat-icon>cloud_download</mat-icon> &nbsp;
		<span>{{ _t('audit-pdf-dialog-span-1') }}</span>
    </a>
</p>

<p><span>{{ _t('audit-pdf-dialog-span-2') }}</span> :<br>
<button mat-raised-button color="warn" (click)="choose(true)">
	<mat-icon>class</mat-icon> &nbsp;
	<span>{{ _t('audit-pdf-dialog-span-3') }}</span></button></p>

<p><mat-icon color="warn">warning</mat-icon><strong>Attention :</strong> <span>{{ _t('audit-pdf-dialog-span-4') }}</span>, <strong>{{ _t('audit-pdf-dialog-strong-0') }}</strong>. 
<span>{{ _t('audit-pdf-dialog-span-5') }}</span>.<br/>
<strong>{{ _t('audit-pdf-dialog-strong-1') }}</strong>.<br/>
<span>{{ _t('audit-pdf-dialog-span-6') }}</span>.
</p>


<p><span>{{ _t('audit-pdf-dialog-span-7') }}</span> : <br>	
<button mat-raised-button color="basic" (click)="choose(false)" >
	<mat-icon>arrow_back_ios</mat-icon> &nbsp;
	<span>{{ _t('audit-pdf-dialog-span-8') }}</span>
</button>
</p>

</ng-container>